import { cn } from "@/lib/utils";

export const Panel = ({ title, subtitle, actions, children, className, bodyClassName, testId }) => (
  <section data-testid={testId} className={cn("panel flex flex-col min-w-0", className)}>
    {(title || actions) && (
      <header className="flex items-center justify-between gap-2 px-3 h-9 border-b border-border/80 bg-muted/30">
        <div className="flex items-baseline gap-2 min-w-0">
          <h3 className="panel-title truncate">{title}</h3>
          {subtitle && <span className="text-[11px] text-muted-foreground/70 font-mono truncate">{subtitle}</span>}
        </div>
        {actions && <div className="flex items-center gap-1.5 shrink-0">{actions}</div>}
      </header>
    )}
    <div className={cn("flex-1 min-h-0", bodyClassName)}>{children}</div>
  </section>
);
